import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = getFeaturedArticles();

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-10">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门爆料
          </h2>
          <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">HOT</span>
        </div>
        <p className="text-sm text-foreground-500">今日最火爆的娱乐圈内幕，吃瓜群众都在看</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {featured.slice(0, 4).map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className={`group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 ${
              index === 0 ? 'md:col-span-2 md:row-span-2' : ''
            }`}
          >
            <div className={`relative overflow-hidden ${index === 0 ? 'h-64 md:h-full' : 'h-44'}`}>
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              {index === 0 && (
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-bold rounded-md">
                  头条爆料
                </div>
              )}
              <div className="absolute bottom-3 left-3 right-3">
                {index === 0 ? (
                  <>
                    <span className="text-xs text-accent-300 font-medium">{article.categoryName}</span>
                    <h3 className="text-lg md:text-xl font-heading font-bold text-white mt-1 line-clamp-2 group-hover:text-primary-300 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-white/70 mt-1 line-clamp-2 hidden md:block">{article.excerpt}</p>
                    <div className="flex items-center gap-4 mt-2 text-xs text-white/50">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line"></i>{(article.viewCount / 10000).toFixed(0)}万
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-message-2-line"></i>{article.commentCount}
                      </span>
                      <span className="whitespace-nowrap">{article.publishDate}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="text-xs text-accent-300 font-medium">{article.categoryName}</span>
                    <h3 className="text-sm font-bold text-white mt-1 line-clamp-2 group-hover:text-primary-300 transition-colors">
                      {article.title}
                    </h3>
                  </>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}